import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        id="Vector"
        fill={colorValue}
        fillOpacity="1"
        d="M7 .5A6.5 6.5 0 1 0 13.5 7 6.507 6.507 0 0 0 7 .5M12.5 7c0 .706-.135 1.405-.4 2.059L9.306 7.34a1 1 0 0 0-.39-.14L7.49 7.01a1.01 1.01 0 0 0-1 .491h-.545l-.238-.491a1 1 0 0 0-.687-.542l-.5-.108.489-.859h1.044c.17 0 .335-.043.483-.125l.766-.423q.101-.056.187-.133l1.682-1.521a.996.996 0 0 0 .204-1.23l-.023-.04A5.51 5.51 0 0 1 12.5 7m-11 0c0-.817.182-1.625.534-2.362l.709 1.891a1 1 0 0 0 .726.625l1.34.289.237.495a1.01 1.01 0 0 0 .9.562h.093l-.452 1.014a1 1 0 0 0 .179 1.086l.008.009L7 11.87l-.121.625A5.507 5.507 0 0 1 1.5 7"
      ></path>
    </svg>
  );
};
